import apiClient from "./client";

export async function fetchForumCategories(signal) {
  const response = await apiClient.get("forum/categories/", { signal });
  return response.data;
}

export async function fetchForumTopics(params = {}, signal) {
  const response = await apiClient.get("forum/topics/", { params, signal });
  return response.data;
}

export async function fetchForumTopic(topicId, signal) {
  const response = await apiClient.get(`forum/topics/${topicId}/`, { signal });
  return response.data;
}

export async function createForumTopic(payload) {
  const response = await apiClient.post("forum/topics/", payload);
  return response.data;
}

export async function createForumPost(topicId, body) {
  const response = await apiClient.post(`forum/topics/${topicId}/posts/`, { body });
  return response.data;
}

export async function voteForumPoll(topicId, value) {
  const response = await apiClient.post(`forum/topics/${topicId}/poll-vote/`, { value });
  return response.data;
}

export async function moderateForumTopic(topicId, action, note = "") {
  const response = await apiClient.post(`forum/topics/${topicId}/moderate/`, {
    action,
    note,
  });
  return response.data;
}

export async function moderateForumPost(postId, action, note = "") {
  const response = await apiClient.post(`forum/posts/${postId}/moderate/`, {
    action,
    note,
  });
  return response.data;
}
